<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible" style="text-align: left">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">

      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
                v-model="dataForm.startTime"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
                v-model="dataForm.endTime"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="原因" prop="reason">
        <el-input v-model="dataForm.reason" clearable></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        roleList: [],
        dataForm: {
          id:'',
          startTime: '',
          endTime: '',
          reason:'',
          userid:'',
          username:''
        },
        dataRule: {
          startTime: [{required: true, message: '开始日期不能为空', trigger: 'blur'}],
          endTime: [{required: true, message: '结束日期不能为空', trigger: 'blur'}]
        }
      }
    },
    methods: {
      init (id) {
        console.log(id);
        if(!id) return
        this.dataForm.userid = id

          this.visible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
            if (this.dataForm.userid) {
              this.$http({
                url: `/bjba/exception/findInfoByUserId/` + this.dataForm.userid,
                method: 'get'
              }).then(({data}) => {
                if (data && data.code === 200) {
                  this.dataForm.id = data.data.id
                  this.dataForm.startTime = data.data.startTime
                  this.dataForm.endTime = data.data.endTime
                  this.dataForm.reason = data.data.reason
                  this.dataForm.username = data.data.username
                }
              })
            } else {
              this.dataForm.id=''
              this.dataForm.startTime=''
              this.dataForm.endTime=''
              this.dataForm.reason=''
              this.dataForm.username=''
            }
          })
      },

      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: `/bjba/exception/save/`,
              method: 'post',
              data: this.dataForm
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.visible = false
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.$emit('refreshDataList')
              }
            })
          }
        })
      }

    }
  }
</script>
<style scoped>
  .mod-org {

    .org-list__input,
    .icon-list__input {

      > .el-input__inner {
        cursor: pointer;
      }

    }
    &
    __icon-popover {
      max-width: 350px;
    }

    &
    __icon-list {
      max-height: 380px;
      padding: 0;
      margin: -8px 0 0 -8px;

      > .el-button {
        padding: 8px;
        margin: 8px 0 0 8px;

        > span {
          display: inline-block;
          vertical-align: middle;
          width: 18px;
          height: 18px;
          font-size: 18px;
        }

      }
    }
    .icon-list__tips {
      font-size: 18px;
      text-align: center;
      color: #e6a23c;
      cursor: pointer;
    }

  }
</style>
